import { useRecoveryAccountContext } from "../../Contexts/RecoveryAccountContext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import phone from "../../assets/phone.svg";

const RecoveryOptions = () => {
  const { navigate } = useRecoveryAccountContext();

  const handleBack = () => {
    navigate(-1);
  };
  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" || event.key === " ") {
      callback();
    }
  };
  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center">
      <div className="w-full sm:w-148 flex-grow">
        <div className="sm:w-full h-78 bg-white rounded-xl sm:mt-24">
          <div className="grid grid-cols-1 divide-y">
            <div className="p-4">
              <KeyboardArrowLeftIcon
                className="absolute cursor-pointer"
                onClick={handleBack}
              />

              <div className="text-center font-semibold text-[#1F2328]">
                Recover account
              </div>
            </div>

            <div className="p-4">
              <div>
                <div className="font-bold text-2xl text-[#1F2328]">
                  Account recovery options
                </div>

                <div className="text-[#60656D] mt-2">
                  If you're having trouble accessing your Maxicare account, you
                  have secure recovery options below to choose from.
                </div>
              </div>

              <div className="flex flex-col items-center justify-center mt-4">
                {/* <button
                  className="w-full h-12 sm:w-full transition ease-in-out delay-75 hover:scale-105 border border-[#E3E4E5] rounded-md p-2 cursor-pointer flex items-center"
                  onClick={() => {
                    setRecoveryMode("email");
                    navigate("/recovery-account/email-address");
                  }}
                  onKeyDown={(event) =>
                    handleKeyDown(event, () => {
                      setRecoveryMode("email");
                      navigate("/recovery-account/email-address");
                    })
                  }>
                  <div className="flex flex-row ml-3">
                    <img src={email} alt="email" />
                    <div className="flex flex-col justify-center ml-2">
                      <p className="font-semibold text-[#60656D]">
                        Recover using verified email address
                      </p>
                    </div>
                  </div>
                </button>
                <button
                  id="MaxicareNumber"
                  className="w-full h-12 sm:w-full transition ease-in-out delay-75 hover:scale-105 border border-[#E3E4E5] rounded-md my-3 p-2 cursor-pointer mt-6 flex items-center"
                  onClick={() => {
                    setRecoveryMode("cardNumber");
                    navigate("/recovery-account/maxicare-card-number");
                  }}
                  onKeyDown={(event) =>
                    handleKeyDown(event, () => {
                      setRecoveryMode("cardNumber");
                      navigate("/recovery-account/maxicare-card-number");
                    })
                  }>
                  <div className="flex flex-row ml-3">
                    <img src={card} alt="card" />
                    <div className="flex flex-col justify-center ml-2">
                      <p className="font-semibold text-[#60656D]">
                        Recover account using Maxicare card number
                      </p>
                    </div>
                  </div>
                </button> */}
                <button
                  id="Hotline"
                  className="w-full h-12 sm:w-full transition ease-in-out delay-75 hover:scale-105 border border-[#E3E4E5] rounded-md my-3 p-2 cursor-pointer flex items-center"
                  onClick={() => navigate("/recovery-account/hotline")}
                  onKeyDown={(event) =>
                    handleKeyDown(event, () => {
                      navigate("/recovery-account/hotline");
                    })
                  }
                >
                  <div className="flex flex-row ml-3">
                    <img src={phone} alt="phone" />
                    <div className="flex flex-col justify-center ml-2">
                      <p className="font-semibold text-[#60656D]">
                        Recover account by calling Maxicare hotline
                      </p>
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecoveryOptions;
